import React from 'react';
import { Well, Row, Col, DropdownButton, MenuItem, ControlLabel } from 'react-bootstrap';

const Reasons = ({
    isCreation,
    isEditable,
    reasons,
    selectedReason,
    onReasonChange,
    validations,
}) => (
    <Well>
        <Row>
            <Col sm={6}>
                <Row>
                    <Col sm={4} componentClass={ControlLabel} style={{ marginTop: 5 }}>
                        Reason {isCreation || isEditable ? '*' : ''}
                    </Col>
                    <Col sm={8}>
                        {!isEditable ? (
                            <p style={{ marginTop: 5 }}>{selectedReason || '-'}</p>
                        ) : (
                            <DropdownButton
                                id="reasonsDropdown"
                                title={selectedReason}
                                onSelect={onReasonChange}
                                style={
                                    validations &&
                                    validations.reason && {
                                        borderColor: '#CF142B',
                                    }
                                }
                            >
                                {React.Children.toArray(
                                    reasons.map(reason => (
                                        <MenuItem
                                            key={reason.eventKey}
                                            eventKey={reason.eventKey}
                                            active={selectedReason === reason.eventKey}
                                        >
                                            {reason.label}
                                        </MenuItem>
                                    ))
                                )}
                            </DropdownButton>
                        )}
                        {validations &&
                            validations.reason && (
                                <p style={{ color: '#CF142B', margin: 5 }}>
                                    You must select abnormality reason.
                                </p>
                            )}
                    </Col>
                </Row>
            </Col>
        </Row>
    </Well>
);

export default Reasons;
